"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HS_NO_SUBSCRIPTION = exports.HS_INPAGE = exports.HS_PLUGINS = void 0;
var HS_PLUGINS = 'hsPlugins';
exports.HS_PLUGINS = HS_PLUGINS;
var HS_INPAGE = 'hsInpage';
exports.HS_INPAGE = HS_INPAGE;
var HS_NO_SUBSCRIPTION = 'hsNoSubscriptionLinks';
exports.HS_NO_SUBSCRIPTION = HS_NO_SUBSCRIPTION;